module.exports = __webpack_public_path__ + "static/media/people2.a3dfccdb.jpg";